
import Vue from "vue";
import { NewAlertDestinationsApiFunc, setAccessToken } from "@/api";
import { AlertDestination } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import AlertDestinationEditor from "./components/AlertDestinationEditor.vue";

export type DataType = {
  alertDestination?: AlertDestination;
};

export default Vue.extend({
  name: "AlertDestinationDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    AlertDestinationEditor,
  },

  data(): DataType {
    return {
      alertDestination: undefined,
    };
  },

  mounted(): void {
    this.getAlertDestination();
  },

  methods: {
    async getAlertDestination(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const alertDestinationId = this.$router.currentRoute.params
        .alertDestinationId;
      setAccessToken(this.$auth.accessToken);
      const {
        data,
        err,
      } = await NewAlertDestinationsApiFunc().getAlertDestination(
        companyId,
        alertDestinationId
      );

      if (err != null) {
        this.$handleApiError(err, this.getAlertDestination);
        return;
      }

      this.alertDestination = data;
    },

    async updateAlertDestination(
      alertDestination: AlertDestination
    ): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      const alertDestinationId = this.$router.currentRoute.params
        .alertDestinationId;
      setAccessToken(this.$auth.accessToken);
      const {
        err,
      } = await NewAlertDestinationsApiFunc().updateAlertDestination(
        companyId,
        alertDestinationId,
        alertDestination
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateAlertDestination(alertDestination);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-alert-destinations",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
